import { path } from 'ramda';

import { FEATURE_NAME as $, LIST, FILTER } from './consts';

export const getReports = path([$, LIST]);
export const getReport = (id) => path([$, LIST, id]);

export const getReportsFilters = path([$, FILTER]);
